import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderApplicantsBy',
  pure: false,
})
export class OrderApplicantsByPipe implements PipeTransform {
  transform(array: Array<any>, args?) {
    // Check if array exists, in this case array contains articles and args is an array that has 1 element : !id
    if (array) {
      // get the first element
      const sortOrder = args[0] === '-' ? -1 : 1;
      const sortColumns = args[1].split('.');

      array.sort((a: any, b: any) => {
        let orderVal1 = a;
        let orderVal2 = b;

        sortColumns.forEach(val => {
          // For some applications, the sort field is null. They should be at the end.
          if (orderVal1 == null) {
            orderVal1 = 'zzzzzz';
          } else {
            orderVal1 = orderVal1[val];
          }

          if (orderVal2 == null) {
            orderVal2 = 'zzzzzz';
          } else {
            orderVal2 = orderVal2[val];
          }
        });

        if (typeof orderVal1 === 'string') {
          orderVal1 = orderVal1.toLowerCase();
        }
        if (typeof orderVal2 === 'string') {
          orderVal2 = orderVal2.toLowerCase();
        }

        if (orderVal1 < orderVal2) {
          return sortOrder;
        } else if (orderVal1 > orderVal2) {
          return -1 * sortOrder;
        } else {
          return 0;
        }
      });

      return array;
    }
  }
}
